export default __webpack_public_path__ + "static/media/genesis.6a55f06a.webm";